import { Button, Modal } from 'antd';
import React from 'react';

interface FormModalProps {
  title: string;
  visible: boolean;
  children: any;
  showModal: (e) => void;
  handleCancel: (e) => void;
  handleOk: (e) => void;
}

class FormModal extends React.Component<FormModalProps> {
  public handleCancel = (e) => {
    this.props.handleCancel(e);
  };

  public handleOk = (e) => {
    this.props.handleOk(e);
  };

  render() {
    const { title, visible, children } = this.props;
    return (
      <Modal
        width={'60%'}
        title={title}
        visible={visible}
        onCancel={this.handleCancel}
        onOk={this.handleOk}
        footer={[
          <Button
            style={{ float: 'left' }}
            key='cancel'
            htmlType={'button'}
            onClick={this.handleCancel}
          >
            Annuleren
          </Button>,
          <Button key='save' type='primary' htmlType={'button'} onClick={this.handleOk}>
            Opslaan
          </Button>
        ]}
      >
        {children}
      </Modal>
    );
  }
}

export default FormModal;
